import { render, staticRenderFns } from "./DeleteColIcon.vue?vue&type=template&id=f5d51938"
import script from "./DeleteColIcon.vue?vue&type=script&lang=js"
export * from "./DeleteColIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports